import type { ConversationAgentPreference } from 'lib-shared-types-api';
import moment from 'moment-timezone';

/**
 * Returns the agent preference while it still applies. The backend may keep
 * returning it after `valid_until` has passed, so the date is checked here.
 */
export function getActiveAgentPreference(
  agentPreference: ConversationAgentPreference | undefined,
): ConversationAgentPreference | undefined {
  return agentPreference?.agent && moment(agentPreference.valid_until).isAfter()
    ? agentPreference
    : undefined;
}
